import { UIButton } from '../../shared/UIButton.styles';
import { styled } from '@mui/material/styles';

export const SkipToMainContentButton = styled(UIButton)(({ theme }) => ({
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  top: '-17px',
  display: 'inline-block',
  margin: '10px',

  '&:focus-visible': {
    zIndex: 9999,
    border: 'none',
    height: '40px',
    outline: '2px solid #37a9cc',
    transform: 'translate(0, 16px)',
  },
  [theme.breakpoints.down('sm')]: {
    '&:focus-visible': {
      width: 'calc(100vw - 1rem)',
    },
    '&:focus': {
      width: 'calc(100vw - 1rem)',
    },
  },
}));
